import { cloneDeep } from 'lodash';
import * as VN from './VendorNames';
import * as ff from './FormFields';
import { toBoolean, genTen, genOption, toNum, roundNumD } from '../utils';
import * as aO from '../data/advOptions';
const {
  attendanceOptions,
  cardHolderPresOptions,
  cardPresenceOptions,
  cardRetOptions,
  conditionOptions,
  inputCapOptions,
  terminalOpOptions,
  panEntryOptions,
  pinEntryOptions,
  presentmentOptions,
  securityConditionOptions,
  terminalLocOptions,
  terminalTypeOptions
} = aO.default;

export const getMetaOption = (formData={}, options) => {
  const { vendorName, isAdvance, isPreAuth } = options;
  const forcePost = formData[ff.TRANS_TYPE] === 'CREDIT_ADJUSTMENT' ? true : false;

  const defaultMeta = {
    "card_acceptor": {
      "acquirer_id": genTen(),
      "address": {
        "street": formData[ff.MERCH_ADDRESS] || "",
        "city": formData[ff.MERCH_CITY] || "",
        "state": formData[ff.MERCH_STATE] || "",
        "country": formData[ff.MERCH_COUNTRY] || "US"
      },
      "merchant_number": '123456',
      "mcc": formData[ff.TRANS_MCC] || "5542",
      "name": formData[ff.MERCH_PLATFORM_NAME] || "Synapse",
      "terminal_id": formData[ff.META_TERMINAL_ID] || "100"
    },
    // "fraud_score": {
    //   "score": "001",
    //   "reason": "00"
    // },
    "is_force_post": toBoolean(formData[ff.META_FORCE_POST]) || forcePost,
    "is_recurring": toBoolean(formData[ff.TRANS_RECURRING]) || false,
    ...(isPreAuth && {
      "lifecycle": {
        "interval": "DAYS",
        "value": 7
      }
    }),
    ...(formData[ff.META_LIFECYCLE] && {
      "lifecycle": {
        "interval": formData[ff.META_LIFECYCLE_INT] || "DAYS",
        "value": formData[ff.META_LIFECYCLE] ? roundNumD(formData[ff.META_LIFECYCLE]) : 0
      }
    }),
    "merchant_name": formData[ff.MERCH_PLATFORM_NAME] || "Synapse",
    //"network_id": formData[ff.META_NETWORK_ID ] || "DMC",
  }

  const advancedMeta = {
    "partial_approval_allowed": formData[ff.META_PARTIAL_APPROVAL] || false,
    "point_of_service": {
      "condition_code": formData[ff.META_CONDITION] || "",
      "pan_entry_mode": formData[ff.META_PAN_ENTRY] || genOption(panEntryOptions),
      "pin_entry_mode": formData[ff.META_PIN_ENTRY] || genOption(pinEntryOptions),
      "presentment": {
        "card_presence": formData[ff.META_CARD_PRES] || genOption(cardPresenceOptions),
        "cardholder_presence": formData[ff.META_ACCT_PRES] || genOption(cardHolderPresOptions),
        "security_concern": formData[ff.META_SECU_CON] || genOption(securityConditionOptions),
        "type": formData[ff.META_PRES_TYPE] || genOption(presentmentOptions),
      },
      "terminal": {
        "attendance": formData[ff.META_TERMINAL_ATT] || genOption(attendanceOptions),
        "card_input_capability": formData[ff.META_CARD_INPUT] || genOption(inputCapOptions),
        "card_retention_capability": formData[ff.META_CARD_RETENTION] || genOption(cardRetOptions),
        "location":  formData[ff.META_TERMINAL_LOC] || genOption(terminalLocOptions),
        "operator": formData[ff.META_TERMINAL_OP] ||  genOption(terminalOpOptions),
        "type":  formData[ff.META_TERMINAL_TYPE] || genOption(terminalTypeOptions)
      }
    },
    // default payment type to purchase
    "type": vendorName !== VN.GREEN_DOT ? (formData[ff.TRANS_TYPE] || "PURCHASE") : true
  }

  const extendedDefaultMeta = { ...defaultMeta, ...advancedMeta };
  const restaurantMeta = cloneDeep(extendedDefaultMeta);
  restaurantMeta.merchant_name = 'In-N-Out';
  restaurantMeta.card_acceptor.name = 'In-N-Out';
  restaurantMeta.card_acceptor.mcc = '5812';
  const metaOptions = {
    [VN.VENMO]: {
      "card_acceptor": {
        "acquirer_id": genTen(),
        "mcc": "7399",
        "address": {
          "street": "VENMO",
          "city": "NEW YORK",
          "state": "NY",
          "country": "US"
        },
        "name": "VENMO",
        "terminal_id": "100",
        "merchant_number": '123456',
      },
      // "fraud_score": {
      //   "score": "001",
      //   "reason": "00"
      // },
      "is_force_post": false,
      "is_recurring": true,
      "merchant_name": "VENMO",
      //"network_id": "DMC",
      "partial_approval_allowed": false,
      "point_of_service": {
        "condition_code": "",
        "pan_entry_mode": "KEY_ENTERED",
        "pin_entry_mode": "UNSPECIFIED",
        "presentment": {
          "card_presence": "CARD_NOT_PRESENT",
          "cardholder_presence": "CUSTOMER_NOT_PRESENT",
          "security_concern": "CHANNEL_ENCRYPTED_ELECTRONIC_TRANSACTION",
          "type": "ORIGINAL_PRESENTMENT"
        },
        "terminal": {
          "attendance": "UNATTENDED",
          "card_input_capability": "KEY_ENTERED",
          "card_retention_capability": "DEVICE_CANNOT_RETAIN_CARD",
          "location": "ON_PREMISE",
          "operator": "CUSTOMER_OPERATED",
          "type": "ELECTRONIC_COMMERCE"
        }
      },
      "type": "PURCHASE"
    },
    [VN.PAYPAL]: {
      "card_acceptor": {
        "acquirer_id": genTen(),
        "mcc": "5999",
        "address": {
          "street": "PAYPAL",
          "city": "4029357733",
          "state": "CA",
          "country": "US"
        },
        "name": "PAYPAL",
        "terminal_id": "100",
        "merchant_number": '123456',
      },
      // "fraud_score": {
      //   "score": "001",
      //   "reason": "00"
      // },
      "is_force_post": false,
      "is_recurring": true,
      "merchant_name": "PAYPAL",
      //"network_id": "DMC",
      "partial_approval_allowed": false,
      "point_of_service": {
        "condition_code": "",
        "pan_entry_mode": "KEY_ENTERED",
        "pin_entry_mode": "PIN_ENTRY_NO_CAPABILITY",
        "presentment": {
          "card_presence": "CARD_NOT_PRESENT",
          "cardholder_presence": "CUSTOMER_NOT_PRESENT",
          "security_concern": "CHANNEL_ENCRYPTED_ELECTRONIC_TRANSACTION",
          "type": "ORIGINAL_PRESENTMENT"
        },
        "terminal": {
          "attendance": "UNATTENDED",
          "card_input_capability": "MANUAL",
          "card_retention_capability": "DEVICE_CANNOT_RETAIN_CARD",
          "location": "ON_PREMISE",
          "operator": "CUSTOMER_OPERATED",
          "type": "ELECTRONIC_COMMERCE"
        }
      },
      "type": "PURCHASE"
    },
    [VN.WHOLE_FOODS]: {
      "card_acceptor": {
        "acquirer_id": genTen(),
        "mcc": "5411",
        "address": {
          "street": "292 ASHLAND PL",
          "city": "BROOKLYN",
          "state": "NY",
          "country": "US"
        },
        "name": "WHOLEFDS FTG #10",
        "terminal_id": "100",
        "merchant_number": '123456',
      },
      "is_force_post":false,
      "is_recurring":true,
      "merchant_name": "WHOLEFDS FTG #10",
      //"network_id": "PUL",
      "partial_approval_allowed": true,
      "point_of_service": {
        "condition_code": "",
        "pan_entry_mode": "INTEGRATED_CIRCUIT_CARD",
        "pin_entry_mode": "PIN_ENTRY_CAPABILITY",
        "presentment": {
          "card_presence": "CARD_PRESENT",
          "cardholder_presence": "CUSTOMER_PRESENT",
          "security_concern": "NO_SECURITY_CONCERN",
          "type": "ORIGINAL_PRESENTMENT"
        },
        "terminal": {
          "attendance": "UNATTENDED",
          "card_input_capability": "ICC",
          "card_retention_capability": "DEVICE_CANNOT_RETAIN_CARD",
          "location": "ON_PREMISE",
          "operator": "CUSTOMER_OPERATED",
          "type": "POS_TERMINAL"
        }
      },
      "type": "PURCHASE"
    },
    [VN.AMAZON]: {
      "card_acceptor": {
        "acquirer_id": genTen(),
        "mcc": "5968",
        "address": {
          "street": "Amazon Video",
          "city": "amazon.com",
          "state": "CA",
          "country": "US"
        },
        "name": "Amazon",
        "terminal_id": "100",
        "merchant_number": '123456',
      },
      // "fraud_score": {
      //   "score": "001",
      //   "reason": "00"
      // },
      "is_force_post": false,
      "is_recurring": true,
      "merchant_name": "Amazon",
      //"network_id": "DMC",
      "partial_approval_allowed": false,
      "point_of_service": {
        "condition_code": "",
        "pan_entry_mode": "MANUAL",
        "pin_entry_mode": "UNSPECIFIED",
        "presentment": {
          "card_presence": "CARD_NOT_PRESENT",
          "cardholder_presence": "RECURRING_PAYMENT",
          "security_concern": "NO_SECURITY_CONCERN",
          "type": "ORIGINAL_PRESENTMENT"
        },
        "terminal": {
          "attendance": "ATTENDED",
          "card_input_capability": "KEY_ENTERED",
          "card_retention_capability": "DEVICE_CANNOT_RETAIN_CARD",
          "location": "ON_PREMISE",
          "operator": "CUSTOMER_OPERATED",
          "type": "DIAL_TERMINAL"
        }
      },
      "type": "PURCHASE"
    },
    [VN.GAS_STATION]: {
      "card_acceptor": {
        "acquirer_id": genTen(),
        "mcc": "5542",
        "address": {
          "street": "CHIP ISTP TESTING",
          "city": "Brussels",
          "state": "  ",
          "country": "US"
        },
        "name": "MOBIL",
        "terminal_id": "100",
        "merchant_number": '123456',
      },
      // "fraud_score": {
      //   "score": "001",
      //   "reason": "00"
      // },
      "is_force_post": false,
      "is_recurring": true,
      "lifecycle": {
        "interval": "DAYS",
        "value": 2
      },
      "merchant_name": "MOBIL",
      //"network_id": "DMC",
      "partial_approval_allowed": false,
      "point_of_service": {
        "condition_code": "",
        "pan_entry_mode": "INTEGRATED_CIRCUIT_CARD",
        "pin_entry_mode": "PIN_ENTRY_CAPABILITY",
        "presentment": {
          "card_presence": "CARD_PRESENT",
          "cardholder_presence": "CUSTOMER_PRESENT",
          "security_concern": "NO_SECURITY_CONCERN",
          "type": "ORIGINAL_PRESENTMENT"
        },
        "terminal": {
          "attendance": "UNATTENDED",
          "card_input_capability": "MAG_STRIPE_AND_EMV",
          "card_retention_capability": "DEVICE_CANNOT_RETAIN_CARD",
          "location": "ON_PREMISE",
          "operator": "CUSTOMER_OPERATED",
          "type": "POS_TERMINAL"
        }
      },
      "type": "PURCHASE"
    },
    [VN.GREEN_DOT]: {
      "card_acceptor": {
        "acquirer_id": genTen(),
        "mcc": "5912",
        "address": {
            "street": "",
            "city": "Brooklyn",
            "state": "NY",
            "zipcode": "",
            "country": "US"
        },
        "name": "Duane Reade",
        "terminal_id": "100",
        "merchant_number": '123456',
      },
      "is_force_post": false,
      "is_recurring": false,
      "merchant_name": "Duane Reade",
      //"network_id": "DMC",
      "partial_approval_allowed": false,
      "point_of_service": {
        "condition_code": "",
        "pan_entry_mode": "INTEGRATED_CIRCUIT_CARD",
        "pin_entry_mode": "PIN_ENTRY_CAPABILITY",
        "presentment": {
          "card_presence": "CARD_PRESENT",
          "cardholder_presence": "CUSTOMER_PRESENT",
          "security_concern": "NO_SECURITY_CONCERN",
          "type": "ORIGINAL_PRESENTMENT"
        },
        "terminal": {
          "attendance": "UNATTENDED",
          "card_input_capability": "ICC",
          "card_retention_capability": "DEVICE_CANNOT_RETAIN_CARD",
          "location": "ON_PREMISE",
          "operator": "CUSTOMER_OPERATED",
          "type": "POS_TERMINAL"
        }
      },
      "type": "DEPOSIT"
    },
    [VN.ATM]: {
      "card_acceptor": {
        "acquirer_id": genTen(),
        "mcc": "6011",
        "address": {
          "street": "#601 MISSION ST",
          "city": "SAN FRANCISCO",
          "state": "CA",
          "country": "US"
        },
        "name": "Bank of America",
        "terminal_id": "100",
        "merchant_number": '123456',
      },
      // "fraud_score": {
      //   "score": "001",
      //   "reason": "00"
      // },
      "is_force_post": false,
      "is_recurring": true,
      "merchant_name": "Bank of America",
      //"network_id": "PUL",
      "partial_approval_allowed": false,
      "point_of_service": {
        "condition_code": "",
        "pan_entry_mode": "INTEGRATED_CIRCUIT_CARD",
        "pin_entry_mode": "PIN_ENTRY_CAPABILITY",
        "presentment": {
          "card_presence": "CARD_PRESENT",
          "cardholder_presence": "CUSTOMER_PRESENT",
          "security_concern": "IDENTIFICATION_VERIFIED",
          "type": "ORIGINAL_PRESENTMENT"
        },
        "terminal": {
          "attendance": "UNATTENDED",
          "card_input_capability": "MAG_STRIPE_AND_EMV",
          "card_retention_capability": "DEVICE_CANNOT_RETAIN_CARD",
          "location": "OFF_PREMISE",
          "operator": "CUSTOMER_OPERATED",
          "type": "ATM"
        }
      },
      "type": "CASH"
    },
    [VN.UBER]: {
      "card_acceptor": {
        "acquirer_id": genTen(),
        "mcc": "4121",
        "address": {
          "street": "UBER TECHNOLOGIES INC",
          "city": "SAN FRANCISCO",
          "state": "CA",
          "country": "US"
        },
        "name": "UBER TECHNOLOGIES INC",
        "terminal_id": "100",
        "merchant_number": '123456',
      },
      // "fraud_score": {
      //   "score": "001",
      //   "reason": "00"
      // },
      "is_force_post": false,
      "is_recurring": true,
      "merchant_name": "UBER TECHNOLOGIES INC",
      // "network_id": "DMC",
      "partial_approval_allowed": false,
      "point_of_service": {
        "condition_code": "",
        "pan_entry_mode": "KEY_ENTERED",
        "pin_entry_mode": "UNSPECIFIED",
        "presentment": {
          "card_presence": "CARD_NOT_PRESENT",
          "cardholder_presence": "CUSTOMER_NOT_PRESENT",
          "security_concern": "CHANNEL_ENCRYPTED_ELECTRONIC_TRANSACTION",
          "type": "ORIGINAL_PRESENTMENT"
        },
        "terminal": {
          "attendance": "UNATTENDED",
          "card_input_capability": "KEY_ENTERED",
          "card_retention_capability": "DEVICE_CANNOT_RETAIN_CARD",
          "location": "ON_PREMISE",
          "operator": "CUSTOMER_OPERATED",
          "type": "ELECTRONIC_COMMERCE"
        }
      },
      "type": "PURCHASE"
    },
    [VN.RESTAURANT]: restaurantMeta,

    "default": extendedDefaultMeta
  }

  if (!vendorName || vendorName === VN.CUSTOM) {
    return metaOptions["default"];
  } else {
    return metaOptions[vendorName];
  }
}


